"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTotalUsedSeats = exports.getTotalUsedSeats = function getTotalUsedSeats(attendeeTypes) {
  if (!attendeeTypes) return 0;
  var usedSeats = 0;
  Object.values(attendeeTypes).forEach(function (attendeeType) {
    usedSeats += attendeeType.usedSeats;
  });
  return usedSeats;
};
var hasPlacesLeftForType = exports.hasPlacesLeftForType = function hasPlacesLeftForType(attendeeType, event, totalUsedSeats) {
  var venueCapacity = event.venueCapacity;
  if (venueCapacity && totalUsedSeats >= venueCapacity) return false;
  if (attendeeType.capacity) return attendeeType.availability > 0;
  return true;
};